import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {BsToastEvent} from 'src/app/DataModels/bs-toast-event';
import {BsToastService} from 'src/app/Services/bs-toast-service';

@Component({
  selector: 'app-bs-toaster',
  templateUrl: './bs-toaster.component.html',
  styleUrls: ['./bs-toaster.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BsToasterComponent implements OnInit {
  currentToasts: BsToastEvent[] = [];

  constructor(private toastService: BsToastService,
              private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.subscribeToToasts();
  }

  subscribeToToasts() {
    this.toastService.toastEvents.subscribe((toasts) => {
      const incoming: BsToastEvent = {
        type: toasts.type,
        title: toasts.title,
        message: toasts.message,
      };

      // Upsert behavior: if a toast with the same type and title exists, update its message
      const existingIndex = this.currentToasts.findIndex(
        (t) => t.type === incoming.type && t.title === incoming.title
      );

      if (existingIndex > -1) {
        if (!incoming.message) {
          // Empty message signals dismissal of existing toast with same key
          this.currentToasts.splice(existingIndex, 1);
        } else {
          this.currentToasts[existingIndex] = {...this.currentToasts[existingIndex], message: incoming.message};
        }
      } else {
        if (incoming.message) {
          this.currentToasts.push(incoming);
        }
      }

      this.cdr.detectChanges();
    });
  }

  dispose(index: number) {
    this.currentToasts.splice(index, 1);
    this.cdr.detectChanges();
  }
}
